// Tiny localStorage-backed recent-reasons store. Lets the COD reject
// modal recall the operator's last few rejection notes as inline
// suggestions, so common reasons ("동일 기관 매니저 다수") don't have to
// be retgriped on every decision.
//
// Namespaced under "care-os.recentReasons.<kind>" so we can layer
// additional reason buckets later (e.g. case-close reasons) without
// touching existing data.

const STORAGE_PREFIX = "care-os.recentReasons.";
const DEFAULT_LIMIT = 6;

function storageKey(kind: string): string {
  return `${STORAGE_PREFIX}${kind}`;
}

function safeRead(kind: string): string[] {
  try {
    const raw = window.localStorage.getItem(storageKey(kind));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((s): s is string => typeof s === "string");
  } catch {
    return [];
  }
}

function safeWrite(kind: string, values: string[]): void {
  try {
    window.localStorage.setItem(storageKey(kind), JSON.stringify(values));
  } catch {
    /* quota exhaustion or disabled storage — degrade silently */
  }
}

export function getRecentReasons(kind: string): string[] {
  if (typeof window === "undefined") return [];
  return safeRead(kind);
}

// Push a new reason to the front. De-dupes case-insensitively so "장기 휴식"
// and "장기 휴식 " don't both stay in the list. Trims oversized strings to
// 240 chars to keep storage bounded.
export function pushRecentReason(kind: string, reason: string, limit: number = DEFAULT_LIMIT): void {
  if (typeof window === "undefined") return;
  const trimmed = reason.trim().slice(0, 240);
  if (!trimmed) return;
  const current = safeRead(kind);
  const normalized = trimmed.toLowerCase();
  const next = [trimmed, ...current.filter(r => r.trim().toLowerCase() !== normalized)].slice(0, limit);
  safeWrite(kind, next);
}
